/*
 * @Author: 刘小博
 * @Date: 2023-02-16 14:43:04
 * @LastEditTime: 2023-02-17 14:21:01
 * @LastEditors: 戴旭
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\bonus-computed\data-manage\modules\dataClassifyRouter.js
 * 数据分类
 */
const dataClassifyRouter = [
  // 数据分类
  {
    path: '/bonusReturnSystem/data-classification',
    name: 'bonusReturnSystemDataClassification',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/data-manage/data-classify/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分类', //二级菜单
      title: '数据分类',
    },
  },

  // 数据分类详情
  {
    path: '/bonusReturnSystem/category-detail/:id',
    name: 'bonusReturnSystemCategoryDetail',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/data-manage/data-classify/data-classify-detail/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分类', //二级菜单
      title: '分类详情',
      breadcrumb: [
        {
          title: '数据分类',
          name: 'bonusReturnSystemDataClassification',
        },
      ],
    },
  },

  // 数据分类详情 表格详情
  {
    path: '/bonusReturnSystem/category-table-detail/:table_id/:details_id',
    name: 'bonusReturnSystemCategoryTableDetail',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/data-manage/data-classify/data-classify-detail/Details.vue'
      ),
    meta: {
      SecondaryMenu: '数据分类', //二级菜单
      title: '表格详情',
      breadcrumb: [
        {
          title: '数据分类',
          name: 'bonusReturnSystemDataClassification',
        },
        {
          title: '分类详情',
          name: 'bonusReturnSystemCategoryDetail',
        },
      ],
    },
  },
]

export default dataClassifyRouter
